import React, { useState, useEffect } from 'react';
import styles from './Customer.module.scss';
import classNames from 'classnames/bind';
import { getCustomers } from '~/services/customerService';
import Title from '~/components/Title';
import PushNotification from '~/components/PushNotification';
import LoadingScreen from '~/components/LoadingScreen';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';

const cx = classNames.bind(styles);

function Customers() {
    const [customersArr, setCustomers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const loadCustomers = async () => {
            try {
                const data = await getCustomers();
                setCustomers(data);
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        loadCustomers();
    }, []);

    if (error) {
        const errorMessage = error.response ? error.response.data.message : 'Network Error';
        return <PushNotification message={errorMessage} />;
    }

    if (loading) {
        return <LoadingScreen />;
    }

    return (
        <div className={cx('wrapper')}>
            <div className={cx('inner')}>
                <Title text="Khách hàng" />
                <Swiper
                    spaceBetween={20}
                    slidesPerView={4}
                    breakpoints={{
                        1280: { slidesPerView: 1 },
                        1024: { slidesPerView: 3 },
                        768: { slidesPerView: 2 },
                        0: { slidesPerView: 1 },
                    }}
                    loop={true}
                    modules={[Autoplay]}
                    autoplay={{
                        delay: 2000,
                        disableOnInteraction: false,
                    }}
                >
                    {customersArr.map((customer, index) => (
                        <SwiperSlide key={index} className={cx('slide')}>
                            <div className={cx('customer-card')}>
                                <img
                                    src={`${process.env.REACT_APP_HOST}/uploads/${customer.logo}`}
                                    alt={`Customer ${index}`}
                                    className={cx('customer-image')}
                                />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
}

export default Customers;
